import './MarketStatistics.less';
import React from 'react';
import { dispatch, useReframe } from 'nike-re-framejs';
import {
    bets$$,
    byHeaders$$,
    byHeadersBB$$,
    findBetByBetId
} from 'nike-ui/src/components/market-statistics/reframe/h&s';
import i18n from '@i18n';
import MarketStatistics, {
    MarketStatisticsHeader
} from 'nike-ui/src/components/market-statistics/view/MarketStatistics';
import MarketStatisticsAccordion from 'nike-ui/src/components/market-statistics/view/MarketStatisticsAccordion';
import SportEventContext from 'nike-ui/src/common/SportEventContext';
import { togglePick } from '@/betslip/handlers';
import BlockLoader from '@/ui/BlockLoader';
import { getPickId, isPickSelected$$ } from 'nike-ui/src/components/betslip/subs';

function EmptyMarketStatistics() {
    return (
        <div className="market-statistics-empty-text flex c-black-50 px-20 py-30">
            {i18n('marketStatistics.emptyBets')}
        </div>
    );
}

function addPick(pick) {
    dispatch(togglePick(pick));
}

function MarketStatisticsHolder({ sportId, live, sportEvent, market = null, matchId }) {
    const { derefSub } = useReframe();
    const sportEventId = sportEvent?.get('sportEventId');
    const bets = derefSub(bets$$(sportEventId || matchId));
    const headers = live
        ? derefSub(byHeaders$$(sportEventId || matchId))
        : derefSub(byHeadersBB$$(sportEventId || matchId));

    function isSelected(betId, selection) {
        const { isSelected } = derefSub(isPickSelected$$(getPickId(betId, selection)));
        return isSelected;
    }

    if (!bets) {
        return <BlockLoader />;
    }
    if (bets.size === 0) {
        return <EmptyMarketStatistics />;
    }

    let filteredHeader;
    if (market !== null) {
        filteredHeader = headers.find(header => header.get('header') === market);
    }

    return (
        <>
            <MarketStatisticsHeader live={live} />
            {filteredHeader ? (
                <SportEventContext.Provider value={sportEvent} key={filteredHeader.get('header')}>
                    <MarketStatisticsAccordion
                        key={filteredHeader.get('header')}
                        title={filteredHeader.get('header')}
                        className={`market-stats bg-${sportId}`}
                    >
                        {filteredHeader.get('betIds').map((betId, betIndex) => (
                            <MarketStatistics
                                key={betId}
                                bet={findBetByBetId(bets, betId)}
                                addPick={addPick}
                                isSelected={isSelected}
                                oddColored={filteredHeader.get('betIds').size > 1 && betIndex % 2 !== 0}
                                live={live}
                            />
                        ))}
                    </MarketStatisticsAccordion>
                </SportEventContext.Provider>
            ) : (
                headers.map((header, index) => (
                    <SportEventContext.Provider value={sportEvent} key={index}>
                        <MarketStatisticsAccordion
                            key={index}
                            title={header.get('header')}
                            className={`market-stats bg-${sportId}`}
                        >
                            {header.get('betIds').map((betId, betIndex) => (
                                <MarketStatistics
                                    key={betId}
                                    bet={findBetByBetId(bets, betId)}
                                    addPick={addPick}
                                    isSelected={isSelected}
                                    oddColored={header.get('betIds').size > 1 && betIndex % 2 !== 0}
                                    live={live}
                                />
                            ))}
                        </MarketStatisticsAccordion>
                    </SportEventContext.Provider>
                ))
            )}
        </>
    );
}

export default MarketStatisticsHolder;
